<template>
  <div class="container-fluid">
    <div class="row flex-row">
      <!-- <div class="col-xl-3">
        <div class="widget has-shadow">
          <div class="widget-body">
            <h3 class="text-center mt-3 mb-1">{{ item.title }}</h3>
            <p class="text-center">{{ itemKind().name }}</p>
            <p class="text-center">{{ item.isAvailable ? 'فعال' : 'غیر فعال' }}</p>
            <div class="em-separator separator-dashed"></div>
          </div>
        </div>
      </div> -->
      <div class="col-xl-9">
        <div class="widget has-shadow">
          <div class="widget-header bordered no-actions d-flex align-items-center">
            <h4>اطلاعات ایتم</h4>
          </div>
          <div class="widget-body">
            <form id="shopform" class="form-horizontal">
              <!-- item kind -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">دسته بندی</label>
                <div class="col-lg-6">
                  <select class="form-control" name="itemKind" v-model="itemKind" @change="itemTypeChanged">
                    <option value selected disabled>انتخاب کنید</option>
                    <option value="Skin">مهره</option>
                    <option value="Avatar">اواتار</option>
                    <option value="Formation">ترکیب</option>
                    <option value="Chat">ایموجی</option>
                    <option value="coin">سکه</option>
                    <option value="ticket">بلیط</option>
                  </select>
                </div>
              </div>

              <!-- game item -->
              <div
                v-if="itemKind != 'coin' && itemKind != 'ticket' && itemKind != ''"
                class="form-group row d-flex align-items-center mb-5"
              >
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">ایتم ها</label>
                <div class="col-lg-6">
                  <select class="form-control" name="item">
                    <option value selected disabled>انتخاب کنید</option>
                    <option v-for="(gameItem, index) in itemsToAdd" :key="index" :value="gameItem._id">
                      "{{ gameItem.name }}" index in app: "{{ gameItem.index }}"</option
                    >
                  </select>
                </div>
              </div>

              <div v-if="itemKind == 'coin'" class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">تعداد سکه</label>
                <div class="col-lg-6">
                  <input class="form-control" type="number" name="coinValue" id="" min="1" />
                </div>
              </div>

              <div v-if="itemKind == 'ticket'" class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">تعداد بلیط</label>
                <div class="col-lg-6">
                  <input class="form-control" type="number" name="ticketCount" id="" min="1" />
                </div>
              </div>
              <!-- title -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">عنوان در فروشگاه</label>
                <div class="col-lg-6">
                  <input type="text" name="title" class="form-control" />
                </div>
              </div>
              <!-- purchase method -->
              <!-- <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">نوع پرداخت</label>
                <div class="col-lg-6">
                  <select class="form-control" name="paymentType" id="">
                    <option value selected disabled>انتخاب کنید</option>
                    <option value="coin">سکه</option>
                    <option value="cash">نقد</option>
                  </select>
                </div>
              </div> -->

              <!-- price -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">هزینه</label>
                <div class="col-lg-6">
                  <input type="number" min="0" name="price" class="form-control" />
                </div>
              </div>

              <!-- discount -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">تخفیف</label>
                <div class="col-lg-6">
                  <input type="number" min="0" name="discount" class="form-control" />
                </div>
              </div>

              <!-- dollar price -->
              <div
                v-if="itemKind == 'coin' || itemKind == 'ticket'"
                class="form-group row d-flex align-items-center mb-5"
              >
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">هزینه دلاری</label>
                <div class="col-lg-6">
                  <input type="number" name="dollarPrice" class="form-control" />
                </div>
              </div>

              <!-- dollar discount -->
              <div
                v-if="itemKind == 'coin' || itemKind == 'ticket'"
                class="form-group row d-flex align-items-center mb-5"
              >
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">تخفیف دلاری</label>
                <div class="col-lg-6">
                  <input type="number" name="dollarDiscount" class="form-control" />
                </div>
              </div>

              <!-- order -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">ترتیب</label>
                <div class="col-lg-6">
                  <input type="number" min="0" name="order" class="form-control" />
                </div>
              </div>

              <!-- is available -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">وضعیت</label>
                <div class="col-lg-6">
                  <select class="form-control" name="isAvailable" id="">
                    <option value selected disabled>انتخاب کنید</option>
                    <option value="true">فعال</option>
                    <option value="false">غیر فعال</option>
                  </select>
                </div>
              </div>

              <!-- check min level -->
              <div
                v-if="itemKind == 'Skin' || itemKind == 'Formation'"
                class="form-group row d-flex align-items-center mb-5"
              >
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">دسترسی با سطح کاربر</label>
                <div class="col-lg-6">
                  <input type="checkbox" name="checkMinLevel" id="checkminlevel" />
                </div>
              </div>

              <!-- min level -->
              <div
                v-if="itemKind == 'Skin' || itemKind == 'Formation'"
                class="form-group row d-flex align-items-center mb-5"
              >
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end"
                  >مینیمم سطح کاربر برای دریافت</label
                >
                <div class="col-lg-6">
                  <input type="number" min="0" class="form-control" name="minLevel" id="minlevel" />
                </div>
              </div>

              <!-- check license -->
              <!-- <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">دسترسی با لایسنس</label>
                <div class="col-lg-6">
                  <input type="checkbox" name="checkLicense" id="checkminlevel" />
                </div>
              </div> -->
            </form>
            <div class="em-separator separator-dashed"></div>
            <div class="text-right">
              <button class="btn btn-gradient-01 mr-4" @click="save">ذخیره تغییرات</button>
              <router-link class="btn btn-shadow" to="/dashboard/shop">بازگشت</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End Row -->
  </div>
</template>

<script>
import shopService from '../../../../services/shop';
export default {
  name: 'shopdetail',
  props: ['shopId'],
  data() {
    return {
      itemsToAdd: [],
      itemKind: '',
      shopItems: [],
    };
  },
  created() {
    this.getsShopItems();
  },
  methods: {
    async getsShopItems() {
      const items = await shopService.getItems();
      this.shopItems = items;
      console.log(items);
    },

    price() {
      if (this.item.coinAvailable) return { price: this.item.coinPrice, discount: this.item.coinDiscount };
      if (this.item.cashAvailable) return { price: this.item.cashPrice, discount: this.item.cashDiscount };
      return { price: 'نامشخص', discount: 'نامشخص' };
    },
    async itemTypeChanged() {
      if (this.itemKind == 'coin' || this.itemKind == 'ticket') {
        // coin value
      } else {
        switch (this.itemKind) {
          case 'Avatar': {
            const avatarItems = await shopService.avatars();

            let i;
            for (i = 0; i < avatarItems.length; i++) {
              avatarItems[i].name = avatarItems[i]['avatarName'];
              avatarItems[i].index = avatarItems[i]['avatarIndex'];
              delete avatarItems[i].avatarName;
              delete avatarItems[i].avatarIndex;
            }
            const alreadyExistAvatars = this.shopItems[3].items;
            this.itemsToAdd = avatarItems.filter(a => {
              const avatar = alreadyExistAvatars.find(b => b.avatar._id == a._id);
              return a.isDefault == false && !avatar;
            });
            break;
          }
          case 'Skin': {
            const skinItems = await shopService.skins();
            let j;
            for (j = 0; j < skinItems.length; j++) {
              skinItems[j].name = skinItems[j]['skinName'] + ' ' + skinItems[j].skinCat;
              skinItems[j].index = skinItems[j]['skinIndex'];
              delete skinItems[j].skinName;
              delete skinItems[j].skinIndex;
            }
            const alreadyExistSkin = this.shopItems[0].items;
            this.itemsToAdd = skinItems.filter(a => {
              const skin = alreadyExistSkin.find(b => b.skin._id == a._id);
              return a.isDefault == false && !skin;
            });
            break;
          }
          case 'Formation': {
            const formationItems = await shopService.formations();
            let k;
            for (k = 0; k < formationItems.length; k++) {
              formationItems[k].name = formationItems[k]['formationName'];
              formationItems[k].index = formationItems[k]['formationIndex'];
              delete formationItems[k].skinName;
              delete formationItems[k].skinIndex;
            }
            const alreadyExistFormation = this.shopItems[1].items;
            this.itemsToAdd = formationItems.filter(a => {
              const formation = alreadyExistFormation.find(b => b.formation._id == a._id);
              return a.isDefault == false && !formation;
            });
            break;
          }
          case 'Chat': {
            const chatItems = await shopService.chats();

            let l;
            for (l = 0; l < chatItems.length; l++) {
              chatItems[l].name = chatItems[l]['packageTitle'];
              chatItems[l].index = chatItems[l]['chatIndex'];
              delete chatItems[l].packageTitle;
              delete chatItems[l].chatIndex;
            }
            const alreadyExistChat = this.shopItems[2].items;
            this.itemsToAdd = chatItems.filter(a => {
              const chat = alreadyExistChat.find(b => b.chat._id == a._id);
              return a.isDefault == false && !chat;
            });
            break;
          }

          default:
            break;
        }
        if (this.itemsToAdd.length == 0)
          window.notif({ isError: true, mssg: 'تمامی ایتم های این دسته بندی در فروشگاه هستند' });
        // get items
      }
    },
    async save() {
      try {
        const form = document.getElementById('shopform');
        if (form.itemKind.value == '') return window.notif({ isError: true, mssg: 'دسته بندی را مشخص کنید' });
        if (form.item && form.item.value == '') return window.notif({ isError: true, mssg: 'ایتمی انتخاب نکرده اید' });
        const body = {
          title: form.title.value,
          isAvailable: form.isAvailable.value == 'true',
          checkLicense: false,
          checkMinLevel: form.checkMinLevel ? form.checkMinLevel.checked : false,
          minLevel: form.minLevel ? form.minLevel.value : 0,
          itemKind: form.itemKind.value,
          order: form.order.value,
        };

        if (body.itemKind == 'coin') {
          body.cashAvailable = true;
          body.coinAvailable = false;
          body.cashPrice = form.price.value;
          body.cashDiscount = form.discount.value;
          body.dollarPrice = form.dollarPrice.value;
          body.dollarDiscount = '';
          body.coinValue = form.dollarDiscount.value;
        } else if (body.itemKind == 'ticket') {
          body.cashAvailable = true;
          body.coinAvailable = false;
          body.cashPrice = form.price.value;
          body.cashDiscount = form.discount.value;
          body.dollarPrice = form.dollarPrice.value;
          body.dollarDiscount = '';
          body.ticketCount = form.ticketCount.value;
        } else {
          body.item = form.item.value;
          body.coinAvailable = true;
          body.cashAvailable = false;
          body.coinPrice = form.price.value;
          body.coinDiscount = form.discount.value;
        }

        const res = await shopService.addItem(body);
        window.notif({ isError: false, mssg: 'ذخیره شد' });
        this.item = res;
        console.log(res);
      } catch (err) {
        window.notif({ isError: true, mssg: 'مشکلی پیش آمده' });
        console.log(err);
      }
    },
  },
};
</script>
